export function packAssignedTo(form) {
  const ids = String(form.individualEmployeeIds || "")
    .split(/[\s,]+/)
    .map((x) => Number(x))
    .filter((n) => Number.isFinite(n) && n > 0);
  return {
    allEmployees: !!form.allEmployees,
    branches: form.branch ? [form.branch] : [],
    departments: form.department ? [form.department] : [],
    designations: form.designation ? [form.designation] : [],
    grades: form.grade ? [form.grade] : [],
    categories: form.category ? [form.category] : [],
    subDepartments: form.subDepartment ? [form.subDepartment] : [],
    employmentTypes: Array.isArray(form.employmentTypes) ? form.employmentTypes : [],
    employees: ids,
  };
}

export function unpackAssignedTo(assignedTo = {}) {
  const a = assignedTo && typeof assignedTo === "object" ? assignedTo : {};
  const first = (arr) => (Array.isArray(arr) && arr.length ? String(arr[0]) : "");
  return {
    allEmployees: a.allEmployees !== false && !a.branches?.length && !a.departments?.length,
    branch: first(a.branches),
    department: first(a.departments),
    designation: first(a.designations),
    grade: first(a.grades),
    category: first(a.categories),
    subDepartment: first(a.subDepartments),
    location: "",
    employmentTypes: Array.isArray(a.employmentTypes) ? a.employmentTypes : [],
    individualEmployeeIds: (a.employees || []).join(", "),
  };
}

export const LOAN_APPROVAL_METHODS = [
  { value: "auto_approved", label: "Auto approved", hint: "No approval chain" },
  { value: "workflow", label: "Through workflow", hint: "Multi-step reviewers" },
];

export const LOAN_WORKFLOW_TABS = [
  { id: "approval", label: "Loan application", key: "workflowSteps", chainLabel: "loan application" },
];

export const ENCASH_WORKFLOW_TABS = [
  {
    id: "approval",
    label: "Encashment request",
    key: "workflowSteps",
    chainLabel: "leave encashment request",
  },
];

export const pwInput =
  "w-full rounded-md border border-[hsl(var(--ds-border))] bg-[hsl(var(--ds-surface))] px-2.5 py-2 text-sm text-[hsl(var(--ds-fg))] outline-none focus:border-[hsl(var(--ds-primary))] focus:ring-2 focus:ring-[hsl(var(--ds-ring))]";
